<template>
  <v-container fluid class="city-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/city/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="cities-table"
              show-select
              single-select
              item-key="_id"
              sort-by="cityname"
              :footer-props="footer"
              :headers="headers"
              :items="cities"

              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this City?
                    </v-card-title>

                    <v-card-text>
                      {{ deleteCity.cityname }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deleteCity)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.cityname="{ item }">
                <a class="primaryConst--text">{{ item.cityname }}</a>
              </template>
              <template v-slot:item.cityemail="{ item }">
                <a class="primaryConst--text">{{ item.cityemail }}</a>
              </template>
              <template v-slot:item.cityid="{ item }">
                {{ item.cityid }}
              </template>
              <template v-slot:item.citystatus="{ item }">
                <v-chip
                  :color="!item.citystatus ? 'primaryConst white--text' : 'secondaryConst white--text'"
                  small>
                  {{ item.citystatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-US", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'cityList',
  data() {
    return {
      snackbar: null,
      dialog: false,
      deleteCity: {},
      headers: [
        { text: 'Type', value: 'citytype' },
        { text: 'Name', value: 'cityname' },
        { text: 'Code', value: 'citycode' },
        { text: 'Status', value: 'citystatus' },
        { text: 'Create', value: 'createdAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      itemPerPage: 100,
      selected: [],
      switch1: true,
      cityid: ['admin', 'city'],
    }
  },

  computed: {
    ...mapState('City', ['cities', 'isReceiving', 'isDeleting', 'idToDelete', 'citiesMessage', 'isUpdating']),
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit city'
    },
  },
  created () {
    this.getCitiesRequest()
  },
  methods: {
    ...mapActions('City', ["getCitiesRequest","deleteCityRequest","updateCityRequest","createCityRequest"]),
    editItem(item) {
      this.$router.push({ name: 'CityEdit', params: item })
    },
    deleteItem(item) {
      this.deleteCityRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deleteCity = {
        _id: item._id,
        cityname: item.cityname,
      }
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
